import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import templateUrl from 'emun.order/order-note-prompt.htm'
import config from 'emun.order/order.config'

function OrderNotePromptController($rootScope, $uibModalInstance, options) {
  var $ctrl = this;
  var model = $ctrl.model = options.model;
  var bus = $ctrl.bus = new ServiceBus($rootScope);
  $ctrl.title = 'ORDER NOTE...';
  $ctrl.config = config;
  if (options.title) {
    $ctrl.title = options.title;
  }


  $ctrl.save = $ctrl.submit = function () {
    if (model.order) {
      $ctrl.model.note.orderNumber = model.order.id;
    }
    if ($ctrl.model.note.id) {
      bus.send('UpdateOrderNote.json', $ctrl.model.note).then(function (response) {
        $rootScope.$emit('orderNoteSaved', $ctrl);
        $uibModalInstance.close($ctrl.model);
      });
    } else {
      bus.send('CreateOrderNote.json', $ctrl.model.note).then(function (response) {
        $rootScope.$emit('orderNoteSaved', $ctrl);
        $uibModalInstance.close($ctrl.model);
      });
    }
  };
  $ctrl.delete = function () {
    $uibModalInstance.close($ctrl.model);
    return modals.confirm("Are you sure?", "Delete Note").result.then(function () {
      $ctrl.bus.send('DeleteOrderNote.json', $ctrl.model.note).then(function (response) {
        $rootScope.$emit('orderNoteDeleted', $ctrl);
      });
    });
  }
  //$ctrl.vendors = new AutoQuery({
  //    url: 'QueryVendors.json?Active=1',
  //    orderBy: 'Label',
  //    autoLoad: true,
  //    pageSize: 100
  //})
  $ctrl.dismiss = function () {
    $uibModalInstance.dismiss();
  };
  $ctrl.toggleAlert = function () {
    let $ctrl = this;
    $ctrl.model.note.alert ? $ctrl.model.note.alert = false : $ctrl.model.note.alert = true;
  }
}

const OrderNotePrompt = {
  open(options) {
    return modals.open(angular.extend({
      size: 'md',
      // placement: 'right',
      //backdrop: false,
      templateUrl: templateUrl,
      resolve: {
        options: () => options
      },
      controller: OrderNotePromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;
  }
};


export default OrderNotePrompt;